//detail page-1 of case study

import React from 'react'
import "./Resources.css"

const Casestudy_1 = () => {
  return (
<>
{/* //top bar */}

<div style={{ width: "100%", backgroundColor: 'rgb(23,76,67)', height:"220px",marginBottom:'40px',paddingTop:"40px"} }>

<h6 style={{color:'rgb(17,175,107)',textAlign:"center" ,fontSize:"30px"}} >CASE STUDY</h6>
   

   <h1 style={{color: "white",textAlign:"center",fontSize:"30px"}}>
   Amerifirst’s Social Selling Program with Lately.ai
   </h1>
</div>


{/* //middle bar */}


<div id='Maintop'>
  <div  id="left">
    <img src="https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/609b075836e6a710b3962ecd_1573226729995.jpeg" style={{width:"150px",borderRadius:"50%"}}></img>
    <br></br>
    <h3 >Josh Switzer</h3>
    <p>Marketing Specialist,<br/> Amerifirst</p>
    <br/>
    <img src="https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/609b04d816f2a5e189b6b67a_Amerifirst-jpg-1024x309-p-500.jpeg" style={{width:"150px"}}></img>
  </div>

  <div id='right'>
    <h3>AmeriFirst – Scaling a Compliant Social Media Program Across Regional Branches with Lately.ai</h3>
    <p>Amerifirst provides affordable home loan financing for thousands of individuals and families each year, especially in rural and underserved communities. With 250 licensed loan officers in branches across Michigan, Florida, Texas, Wisconsin, North Carolina and South Carolina, they needed a way to scale social media support for all their branches, without having the local social media content sound too corporate.

In 2019 Amerifirst selected Lately.ai to create and scale social media programs across their regional branches
Amerifirst’s loan officers are experts at refinancing options, conventional, FHA, VA, USDA Rural Development, and renovation loans. But, like many great sales people, their loan officers were very busy and struggled to find time to nurture their online community. So Amerifirst’s Regional Marketing and Sales Team developed a plan to support each individual loan officer and branch with high-quality social media content to bolster their local credibility and visibility. In 2019 the marketing team selected the Lately Social A.I. Content Platform to create and scale high-quality social media content across all their local branches in an efficient and compliant way.
<br/>
Before using Lately every branch and loan officer was on their own, and the marketing team struggled to keep up with the growing number of ‘one-off’ post and content requests for the growing community. Now with Lately, Amerifirst easily scales great content development and deployment that is always on brand and compliant. The regional Amerifirst loan officers still post organic, personalized content to their pages, supplemented by a constant stream of social media content that is published on their behalf by the Regional Marketing team.
<br/>
<br/>
“Lately is the backbone of our social media strategy. We use Lately to create on brand, compliant content and centrally manage social media on behalf of our local branches.”
</p>
<br/>
<img src="https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/60a418a38c15a7748177e070_ameriimg.png" style={{width:"860px"}}></img>
<br></br>
<br/>
<h3>Success with Lately</h3>
<br/>
<p>
Amerifirst’s compliant social media program success with Lately:

Loan officers are able to build their personal brands on social media with pre-approved compliant content
<br/>
Two marketing specialists on our marketing team provide high-quality social media content for all branches and loan officers as a centralized service
Team uses Lately’s centralized content review and approval workflows to ensure all social media is on brand and legally compliant prior to publishing
Loan officers and branch managers can let marketing publish to their social media channels on their behalf and also publish on their own from a list of curated and approved content
Lately’s A.I. 
<br/>helps team ensure all social media content is on message, and streamlines creation of localized content for each branch
</p>

  </div >

</div>
<br/>
<br/>

{/* //bottom bar */}
<div style={{ width: "100%", backgroundColor: 'rgb(23,76,67)', height:"300px",marginBottom:'40px',paddingTop:"40px"} }>

<h3 style={{color:'white',textAlign:"center"}} >“Lately helps us create and publish engaging content on
<br/> behalf of our loan officers and branches all across the country.”</h3>
   
<div  id="left" style={{display:"flex", color:"white",margin:"auto"}} >
    <div>
    <img src="https://global-uploads.webflow.com/5fecd74b489ca969cf5a3848/609b075836e6a710b3962ecd_1573226729995.jpeg" style={{width:"150px",borderRadius:"50%",marginRight:"50px"}}></img>
    </div>
    <br></br>
    <div>
    <h4>Josh Switzer</h4>
    <p>Marketing Specialist,<br/> Amerifirst</p>
    </div>
    <br/>
   
  </div>
 
</div>

</>
  )
}

export default Casestudy_1